export class State {
    balanceError = {};
    balanceSuccess = {};
    isBalanceLoading = false;
    balanceItem = {};
    selectedEducation = {};
}
